import { render, staticRenderFns } from "./BFA.vue?vue&type=template&id=608ac08f&scoped=true&"
import script from "./BFA.vue?vue&type=script&lang=js&"
export * from "./BFA.vue?vue&type=script&lang=js&"
import style0 from "./BFA.vue?vue&type=style&index=0&id=608ac08f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608ac08f",
  null
  
)

export default component.exports